import React from 'react';
import { ArrowUpRightIcon, HammerIcon, NewspaperIcon, QuoteIcon } from 'lucide-react';
import { LINKS } from '../data/site';
export function TrustBand() {
  return <section className="border-b border-steel-200 bg-white" aria-label="Why metal workers come to Fournier" data-id="element-260" data-mp="39zmqeu7g9vhp">
      <div className="mx-auto grid max-w-[1240px] divide-y divide-steel-200 px-5 sm:px-8 md:grid-cols-3 md:divide-x md:divide-y-0" data-id="element-261" data-mp="3iyhsbu3gojf7">
        <div className="py-4 md:pr-6" data-id="element-262" data-mp="2m9a7koao2ecc">
          <div className="flex items-start gap-2" data-id="element-263" data-mp="2m64i37y4lag3">
            <HammerIcon aria-hidden="true" className="mt-1 h-[18px] w-[18px] shrink-0 text-fred" data-id="element-264" data-mp="2r6it8yv0x0ic" />
            <h2 className="font-display text-[20px] uppercase leading-tight text-charcoal" data-id="element-265" data-mp="2v8nhfi2pd4xl">
              Established in 1991
            </h2>
          </div>
          <p className="mt-1 max-w-[34ch] text-[14px] leading-relaxed text-steel-600" data-id="element-266" data-mp="301gowdpk2rdd">
            A metal shaping tradition carried forward.
          </p>
          <a href={LINKS.story} className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[13px] font-medium uppercase tracking-[0.08em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-267" data-mp="27i094vovkdai">
            Our story
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-268" data-mp="1r89z619ke38m" />
          </a>
        </div>

        <div className="py-4 md:px-6" data-id="element-269" data-mp="1mai8tbokip6j">
          <div className="flex items-start gap-2" data-id="element-270" data-mp="1m9gn8d9xekak">
            <NewspaperIcon aria-hidden="true" className="mt-1 h-[18px] w-[18px] shrink-0 text-fred" data-id="element-271" data-mp="1hb5fc836yjuz" />
            <h2 className="font-display text-[20px] uppercase leading-tight text-charcoal" data-id="element-272" data-mp="1d8sjcbe8y0be">
              Featured in Road &amp; Track
            </h2>
          </div>
          <p className="mt-1 max-w-[34ch] text-[14px] leading-relaxed text-steel-600" data-id="element-273" data-mp="18bsajsq0ijgl">
            “The English Wheel”
          </p>
          <a href={LINKS.roadAndTrackFeature} target="_blank" rel="noopener noreferrer" className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[13px] font-medium uppercase tracking-[0.08em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-274" data-mp="32o8fmq72nrjv">
            Read the feature
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-275" data-mp="10s9dwjnuirpj" />
          </a>
        </div>

        <div className="py-4 md:pl-6" data-id="element-276" data-mp="r0mtpxtj5ian">
          <div className="flex items-start gap-2" data-id="element-277" data-mp="r1oeiu0clj5k">
            <QuoteIcon aria-hidden="true" className="mt-1 h-[18px] w-[18px] shrink-0 text-fred" data-id="element-278" data-mp="qyag1wut1u3e" />
            <blockquote className="max-w-[34ch] text-[15px] leading-relaxed text-charcoal" data-id="element-279" data-mp="1eod481vlmfwq">
              “Jeff was great, very patient with me…”
            </blockquote>
          </div>
          <p className="mt-1 text-[14px] text-steel-600" data-id="element-280" data-mp="14u4a59qx6ewg">Marshall Banks · Workshop student</p>
          <a href={LINKS.testimonials} className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[13px] font-medium uppercase tracking-[0.08em] text-charcoal transition-colors duration-150 ease-out hover:text-fred" data-id="element-281" data-mp="19p9z6hfmc9or">
            Read customer stories
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-282" data-mp="2chvx1psrp1op" />
          </a>
        </div>
      </div>
    </section>;
}